import Vue from 'vue';
import Router from 'vue-router';

import store from '@/store';
import beforeEach from './beforeEach';

const pattern = /\/(index.html)?#\//;
// import home from './routes/home';
// import about from './routes/about';
// import board from './routes/board';
// import guide from './routes/guide';
// import activity from './routes/activity';

import { SET_TITLE } from '../store/mutationTypes';

let routerList = [];
function importAll(r) {
  r.keys().forEach((item) => {
    routerList = routerList.concat(r(item).default);
  });
}

importAll(require.context('./routes', true, /\.js/));

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: [...routerList],
});

beforeEach.forEach((item) => {
  router.beforeEach(item);
});
const { push, go } = router;
router.go = function nativeBack(options) {
  const originCurrent = (window.history.state || {}).key || '';
  const current = originCurrent.replace(pattern, '/');
  go.apply(this, [options]);
  setTimeout(() => {
    const originBackCurrent = (window.history.state || {}).key || '';
    const backCurrent = originBackCurrent.replace(pattern, '/');
    if (current === backCurrent && window.zeeho.isNativeEnv) {
      window.zeeho.navigateBack({ delta: 1 });
    }
  }, 20);
};
router.push = function nativePush(options) {
  // const { params, query, meta } = this.resolve(options);
  const { params, query, meta } = this.matcher.match(options, this.app.$router);
  const { isMiniapp } = window.app || {};
  const token = JSON.parse(window.localStorage.getItem('token ') || '""');
  // 小程序发送token更换再切换路由;
  if (isMiniapp && meta.miniUrl) {
    const appData = { type: 'changeToken', data: { token } };
    const queryData = Object.assign(params, query);
    const queryStr = Object.keys(queryData)
      .map((key) => `${key}=${queryData[key]}`)
      .join('&');
    window.wx.miniProgram.postMessage(JSON.stringify(appData));
    window.wx.miniProgram.navigateTo({ url: `${meta.miniUrl}${queryStr ? `?${queryStr}` : ''}` });
    return true;
  }
  console.log('跳转', query);
  if (window.zeeho.isNativeEnv && meta.appName) {
    // const appData = { name: meta.appName, params: Object.assign(params, query, { token }) };
    window.zeeho.navigateTo({ url: meta.appName, query });
    return true;
  }
  return push.apply(this, [options]);
};
router.afterEach((route) => {
  const meta = route.meta || {};
  // document.title = meta.title || '';
  document.body.className = meta.backgroundClass || 'bg-white';
  store.commit(SET_TITLE, meta.title || '');
});

export default router;
